import FooterGovCo from './FooterGovCo';
import FooterInfo from './FooterInfo';
import FooterLogos from './FooterLogos';
import styles from './styles.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <FooterLogos />
      <FooterInfo />
      <FooterGovCo />
    </footer>
  );
};

export default Footer;
